export default __webpack_public_path__ + "static/media/WM0530.34I-43332_-25943_15.fd18bec1.jpg";